module.exports = __webpack_public_path__ + "img/1_compativilidad.4752b058.svg";